module.exports = __webpack_public_path__ + "static/media/driving-licence-example.54e0af66.png";